import styled from "styled-components";
import { Play, X } from "@styled-icons/boxicons-regular";
import { Close } from "@styled-icons/ionicons-outline";

import photo1 from "assets/images/Suyane_Mike_HickDuarte_32990.jpg";
import photo2 from "assets/images/Suyane_Mike_HickDuarte_33031.jpg";
import photo3 from "assets/images/Suyane_Mike_HickDuarte_32996.jpg";

import { fonts } from "styles";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  padding: 80px 96px;
  background-color: #010822;
  position: relative;

  @media screen and (max-width: 1024px) {
    padding: 0;
  }
`;

// export const Content = styled.div`
//   width: 100%;
//   height: 100%;
//   width: max-content;
//   position: relative;
// `;

// export const Photo = styled.img.attrs({ src: photo1 })`
//   width: auto;
//   height: auto;
//   max-height: calc(100vh - 160px);
// `;

// export const Photo2 = styled.img.attrs({ src: photo2 })`
//   width: auto;
//   height: auto;
//   max-height: calc(100vh - 160px);
// `;

// export const Photo3 = styled.img.attrs({ src: photo3 })`
//   width: auto;
//   height: auto;
//   max-height: calc(100vh - 160px);
// `;

export const Photo = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 160px);
  background: url(${photo1}) no-repeat center center;
  background-size: cover;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Photo2 = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 160px);
  background: url(${photo2}) no-repeat center center;
  background-size: cover;

  display: flex;
  align-items: flex-end;
  justify-content: center;
  position: relative;

  @media screen and (max-width: 1024px) {
    min-height: 100vh;
    /* background-size: contain; */
  }
`;

export const Photo3 = styled.div`
  width: 100%;
  height: 100%;
  min-height: calc(100vh - 160px);
  background: url(${photo3}) no-repeat center center;
  background-size: cover;

  position: relative;

  @media screen and (max-width: 1024px) {
    display: none;
  }
`;

export const Text = styled.article`
  width: 100%;
  max-width: 150px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  top: 24px;
  right: 24px;
`;

export const Credit = styled.article`
  display: none;
  width: 100%;
  max-width: 150px;
  color: rgba(255, 255, 255, 0.9);
  font-size: 14px;
  line-height: 20px;
  position: absolute;
  top: 24px;
  right: 24px;

  @media screen and (max-width: 1024px) {
    display: block;
  }

  @media screen and (max-width: 414px) {
    font-size: 10px;
    line-height: 16px;
    top: 24px;
    right: 24px;
    color: #4a2b34;
  }
`;

export const ButtonVideo = styled.button.attrs({ type: "button" })`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 16px;
  background-color: white;
  border-radius: 24px;
  color: black;
  font-size: 15px;
  font-family: ${fonts.BentonSansMedium};
  transition: 300ms ease;
  position: absolute;
  z-index: 99;
  bottom: 56px;

  :hover {
    transform: scale(1.1) !important;
  }
`;

export const IconPlay = styled(Play).attrs({ size: 20 })`
  color: black;
  margin-right: 2px;
`;

export const IconX = styled(X).attrs({ size: 20 })`
  color: black;
  margin-right: 2px;
`;

export const ButtonClose = styled.button.attrs({ type: "button" })`
  color: white;
  position: absolute;
  top: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 101;
`;

export const IconClose = styled(Close).attrs({ size: 56 })`
  color: white;
`;

export const Overlay = styled.div<{ active: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 999;
  background: rgba(0, 0, 0, 0.7);
  padding: 32px 0 80px 0;
  display: ${(props) => (props.active ? "block" : "none")};
  overflow: auto;
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);

  @media screen and (max-width: 1024px) {
    background: rgba(1, 8, 34, 1);
  }
`;

export const Video = styled.div<{ active: boolean }>`
  /* display: flex;
  align-items: center !important; */
  width: max-content;
  /* max-width: 356px; */
  overflow: hidden;
  height: 100%;
  border-radius: 8px;
  margin: 0 auto;
  position: relative;
  display: ${({ active }) => (active ? "block" : "none")};
  z-index: 100;
  animation-name: appear;
  animation-duration: 500ms;
  animation-timing-function: ease;
  animation-direction: alternate;

  @keyframes appear {
    0% {
      transform: translateY(+100vh);
    }
    100% {
      transform: translateY(0);
    }
  }

  video {
    /* position: absolute;
    right: 0;
    bottom: 0; */
    object-fit: contain;
    width: auto;
    height: 100%;
  }
`;
